export const black = '#000000';
export const white = '#ffffff';
export const chambray = '#2e4487';
export const ice = '#dfe6f0';
export const sapphire = '#0d2880';
export const night = '#07184d';
